export default __webpack_public_path__ + "static/media/linkChain.35975d2a.svg";